import { render } from "./PurchaseLogsListing.vue?vue&type=template&id=435bbc73&scoped=true&ts=true"
import script from "./PurchaseLogsListing.vue?vue&type=script&lang=ts"
export * from "./PurchaseLogsListing.vue?vue&type=script&lang=ts"

import "./PurchaseLogsListing.vue?vue&type=style&index=0&id=435bbc73&scoped=true&lang=css"
import "./PurchaseLogsListing.vue?vue&type=style&index=1&id=435bbc73&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435bbc73"]])

export default __exports__